// extracted by mini-css-extract-plugin
export var animLine = "Discover-module--animLine--c0k48";
export var containerDiscover = "Discover-module--containerDiscover--g2cwA";
export var line = "Discover-module--line--JdS7x";